export const PANEL_RATE = 15.0;
export const MIN_FEE = 99.0;
export const ROOF_MULT = { single: 1.0, two_story: 1.25, steep: 1.5 };
export const FREQ_MULT = { one_time: 1.0, biannual: 0.85, quarterly: 0.8 };
export const ADDONS = { bird_guard: 75.0, moss_removal: 120.0 };
export const VET_DISCOUNT = 0.15;

export const ROOF_LABELS = {
  single: "Single-Story",
  two_story: "Two-Story",
  steep: "Steep / Tile",
};
export const FREQ_LABELS = {
  one_time: "One-Time",
  biannual: "Bi-Annual · Save 15%",
  quarterly: "Quarterly · Save 20%",
};
export const ADDON_LABELS = {
  bird_guard: "Bird Guard Mesh",
  moss_removal: "Moss & Lichen Removal",
};
export const SLOT_LABELS = {
  morning: "Morning · 8am–12pm",
  afternoon: "Afternoon · 1pm–5pm",
};

export function computeQuote(panels, roofType, frequency, addons, isVeteran) {
  panels = Math.max(1, parseInt(panels, 10) || 1);
  const roofM = ROOF_MULT[roofType] ?? 1.0;
  const freqM = FREQ_MULT[frequency] ?? 1.0;
  let base = Math.max(panels * PANEL_RATE * roofM, MIN_FEE);
  base = Math.round(base * freqM * 100) / 100;
  const addonTotal =
    Math.round(addons.reduce((s, a) => s + (ADDONS[a] || 0), 0) * 100) / 100;
  const subtotal = Math.round((base + addonTotal) * 100) / 100;
  const discount = isVeteran ? Math.round(subtotal * VET_DISCOUNT * 100) / 100 : 0;
  const total = Math.round((subtotal - discount) * 100) / 100;
  const outputGain = Math.min(30, 15 + Math.floor(panels / 4));
  const annualSavings =
    Math.round(panels * 22.5 * (outputGain / 100) * 12 / 3 * 100) / 100;
  return { base, addonTotal, subtotal, discount, total, outputGain, annualSavings };
}

export const money = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(n || 0);
